import { useUserHasPermissions } from '../../common/hooks'

const useCanUserAssignTask = (task, assignPermission) => {
  const hasPermission = useUserHasPermissions([assignPermission])
  return !task.isAssigned && hasPermission
}

export default useCanUserAssignTask
